/**
 * This javascript module contains the different redux actions that are dispatched and handled by
 * this application.
 */

export const GET_DEVICE_PAIRING_LIST = "GET_DEVICE_PAIRING_LIST";
export const GET_NEW_PAIRING_CODE = "GET_NEW_PAIRING_CODE";
export const GET_LICENSES = "GET_LICENSES";


export const FETCH_RESOURCE_REQUEST = "FETCH_RESOURCE_REQUEST";
export const FETCH_RESOURCE_SUCCESS = "FETCH_RESOURCE_SUCCESS";
export const FETCH_RESOURCE_FAILURE = "FETCH_RESOURCE_FAILURE";

export const PATCH_RESOURCE_REQUEST = "PATCH_RESOURCE_REQUEST";
export const PATCH_RESOURCE_SUCCESS = "PATCH_RESOURCE_SUCCESS";
export const PATCH_RESOURCE_FAILURE = "PATCH_RESOURCE_FAILURE";

export const POST_RESOURCE_REQUEST = "POST_RESOURCE_REQUEST";
export const POST_RESOURCE_SUCCESS = "POST_RESOURCE_SUCCESS";
export const POST_RESOURCE_FAILURE = "POST_RESOURCE_FAILURE";

export const PUT_RESOURCE_REQUEST = "PUT_RESOURCE_REQUEST";
export const PUT_RESOURCE_SUCCESS = "PUT_RESOURCE_SUCCESS";
export const PUT_RESOURCE_FAILURE = "PUT_RESOURCE_FAILURE";

export const DELETE_RESOURCE_REQUEST = "DELETE_RESOURCE_REQUEST";
export const DELETE_RESOURCE_SUCCESS = "DELETE_RESOURCE_SUCCESS";
export const DELETE_RESOURCE_FAILURE = "DELETE_RESOURCE_FAILURE";

export const UPLOAD_ASSET_REQUEST = "UPLOAD_ASSET_REQUEST";
export const UPLOAD_ASSET_PROGRESS = "UPLOAD_ASSET_PROGRESS";
export const UPLOAD_ASSET_SUCCESS = "UPLOAD_ASSET_SUCCESS";
export const UPLOAD_ASSET_FAILURE = "UPLOAD_ASSET_FAILURE";

export const CONFIRMATION_REQUEST = "CONFIRMATION_REQUEST";
export const CONFIRMATION_ACCEPT = "CONFIRMATION_ACCEPT";
export const CONFIRMATION_DENY = "CONFIRMATION_DENY";

export const UPDATE_PLAYLIST_TAGS_REQUEST = "UPDATE_PLAYLIST_TAGS_REQUEST";
export const UPDATE_PLAYLIST_TAGS_ACCEPT = "UPDATE_PLAYLIST_TAGS_ACCEPT";
export const UPDATE_PLAYLIST_TAGS_DENY = "UPDATE_PLAYLIST_TAGS_DENY";

export const BULK_PLAYLISTS_UPDATE_REQUEST = "BULK_PLAYLISTS_UPDATE_REQUEST";
export const BULK_PLAYLISTS_UPDATE_ACCEPT = "BULK_PLAYLISTS_UPDATE_ACCEPT";
export const BULK_PLAYLISTS_UPDATE_DENY = "BULK_PLAYLISTS_UPDATE_DENY";

export const SET_PLAYLIST = "SET_PLAYLIST"
export const UPDATE_PLAYLIST = "UPDATE_PLAYLIST"

export const SHOW_UPLOADS_TRAY = "SHOW_UPLOADS_TRAY";
export const HIDE_UPLOADS_TRAY = "HIDE_UPLOADS_TRAY";
export const TOGGLE_UPLOADS_TRAY = "TOGGLE_UPLOADS_TRAY";

export const TOGGLE_UPLOAD_TYPE = "TOGGLE_UPLOAD_TYPE";
export const CHOOSE_UPLOAD = "CHOOSE_UPLOAD";
export const START_SINGLE_UPLOAD = "START_SINGLE_UPLOAD";
export const UPLOAD_BOX_VISIBLE = "UPLOAD_BOX_VISIBLE";
export const START_UPLOAD = "START_UPLOAD";
export const RESUMABLE_TYPE = "RESUMABLE_TYPE";
export const NORMAL_TYPE = "NORMAL_TYPE";
export const REMOVE_START_STATE = "REMOVE_START_STATE";

export const NAVIGATE_TO_RESOURCE = "NAVIGATE_TO_RESOURCE";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_SUCCESS_OTP = "LOGIN_SUCCESS_OTP";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_LOGOUT = "LOGIN_LOGOUT";

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

export const CHANGE_EMAIL_REQUEST = "CHANGE_EMAIL_REQUEST";
export const CHANGE_EMAIL_SUCCESS = "CHANGE_EMAIL_SUCCESS";
export const CHANGE_EMAIL_FAILURE = "CHANGE_EMAIL_FAILURE";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const CONFIRM_RESET_PASSWORD_REQUEST = "CONFIRM_RESET_PASSWORD_REQUEST";
export const CONFIRM_RESET_PASSWORD_SUCCESS = "CONFIRM_RESET_PASSWORD_SUCCESS";
export const CONFIRM_RESET_PASSWORD_FAILURE =
  "LOGIN_CONFIRM_RESET_PASSWORD_FAILURE";

export const SEARCH_ASSETS = "SEARCH_ASSETS";
export const SEARCH_DEVICES = "SEARCH_DEVICES";
export const SEARCH_PLAYLISTS = "SEARCH_PLAYLISTS";

export const SORT_ASSETS = "SORT_ASSETS";

export const SET_PAGE_TITLE = "SET_PAGE_TITLE";
export const FILTER_ASSETS = "FILTER_ASSETS";

export const FILTER_PLAYLISTS = "FILTER_PLAYLISTS";

export const TOGGLE_FILTER_BAR = "TOGGLE_FILTER_BAR";

export const HELP_TOGGLE = "HELP_TOGGLE";

export const SWITCH_ASSETS_VIEW = "SWITCH_ASSETS_VIEW";

export const SET_AQI_CITIES = "SET_AQI_CITIES";
export const SET_AQI_STATIONS = "SET_AQI_STATIONS";
export const SET_AIRVEDA_STATIONS = "SET_AIRVEDA_STATIONS";
export const SET_WEATHER_STATIONS = "SET_WEATHER_STATIONS";

export const SET_QUIZ_STATIONS = "SET_QUIZ_STATIONS";

export const TRANSCODE_VIDEO = "TRANSCODE_VIDEO";

export const SHOW_GROUP_FEED = "SHOW_GROUP_FEED";

export const UPDATE_NEXT = "UPDATE_NEXT";
export const RESET_NEXT = "RESET_NEXT";

export const ADD_CAMPAIGN = "ADD_CAMPAIGN";
export const ADD_FILE_TO_CAMPAIGN = "ADD_FILE_TO_CAMPAIGN";

export const FETCH_EVENTS_LOCATIONS = "FETCH_EVENTS_LOCATIONS";

export const FETCH_PLAYLIST_REQUEST = 'FETCH_PLAYLIST_REQUEST';
export const FETCH_PLAYLIST_SUCCESS = 'FETCH_PLAYLIST_SUCCESS';
export const FETCH_PLAYLIST_FAILURE = 'FETCH_PLAYLIST_FAILURE';



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/constants/actionTypes.js